import { ReactNode } from 'react';
import { useDispatch } from 'src/store/store';
import { Modal as ReactstrapModal } from 'reactstrap';
import i18n from 'src/utils/translate';
import { closeModal } from 'src/modules/shared/modal/actions';
import styled from 'styled-components';
import { CloseButton, Header, Title } from 'styles-js/modals';
import Icon from 'src/components/icon';

type Props = {
  children: ReactNode;
  customMaxWidth?: string,
  isCustomHeader?: boolean;
  isNoClose?: boolean; // modal can't be dismissed by clicking away from it
  isResponsive?: boolean;
  title?: string;
};
export default function Modal({
  children,
  customMaxWidth,
  isCustomHeader = false,
  isNoClose = false,
  isResponsive = false,
  title,
}: Props): JSX.Element {
  const dispatch = useDispatch();

  const Container = isResponsive ? ResponsiveModal : FullscreenModal;

  return (
    <Container
      $customMaxWidth={customMaxWidth}
      backdropClassName="app-modal__backdrop"
      isOpen={true}
      toggle={() => {
        if (!isNoClose) dispatch(closeModal());
      }}
    >
      {!isCustomHeader && (
        <Header>
          {title && <Title>{title}</Title>}
          <CloseButton onClick={() => dispatch(closeModal())}>
            <span>{i18n.t('Close')}</span>
            <Icon icon="cross-2" />
          </CloseButton>
        </Header>
      )}
      {children}
    </Container>
  );
}

// Overwriting reactstrap modal component
const ModalComponent = styled(ReactstrapModal)<{ $customMaxWidth?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: none;
  height: 100%;
  margin: auto;

  .modal-content {
    max-width: ${({ $customMaxWidth }) => $customMaxWidth ? $customMaxWidth : '560px'};
    border-radius: 8px;
    border: none;
    overflow: hidden;
    max-height: 90vh;
    @media (max-height: ${({ theme }) => theme.screenSmMinHeight}) {
      height: 100%;
      max-height: 100vh;
      border-radius: 0;
    }
  }
`;

const FullscreenModal = styled(ModalComponent)`
  .modal-content {
    @media (max-width: ${props => props.theme.screenXsMin}) {
      height: 100%;
      max-height: 100vh;
      border-radius: 0;
    }
  }
`;

const ResponsiveModal = styled(ModalComponent)`
  .modal-content {
    margin: auto 20px;

    @media (${props => props.theme.underScreenXxsmall}) {
      margin: auto 10px;
    }
  }
`;
